<app-topheader></app-topheader>
<div class="scrollingcontainer ">

    <div class="container">
        <app-fancy-page-title topTitle="Café Menu"></app-fancy-page-title>


        <!-- <app-goldbar></app-goldbar> -->

        <div class="tenpxtop"></div>
        <app-longgoldbar></app-longgoldbar>


        <app-cafe-menu></app-cafe-menu>

    </div>
</div>
<app-bottommenu></app-bottommenu>